<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-25 15:50:35
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-01-26 17:09:44
 * @FilePath: \sns-user-frontend\src\components\web\actionBar.vue
 * @Description: 详情页功能栏
-->
<template>
  <div class="action-bar" ref="actionBarRef">
    <div 
      class="action-bar-item"
      v-for="(item, index) in actionList"
      :key="index"
      @click="onAction(item)"
    >

      <svg-icon v-if="item.iconName !== 'more'" :name="`icon-${item.iconName}`" />
      <template v-else>
        <el-popover
          ref="popoverRef"
          placement="left-start"
          trigger="hover"
          width="auto"
        >
          <template #reference>
            <div class="pop-trigger" @mouseenter="enterMoreActicon">
              <svg-icon :name="`icon-${item.iconName}`" />
            </div>
          </template>
          <dl 
            class="action-bar-more"
          >
            <dt
              :class="item.hasline ? 'hasline' : ''"
              v-for="item in moreOptions"
              :key="`${item.name}${item.value}`"
              @click="onHandleThread(item)"
            >{{$t(item.name)}}</dt>
          </dl>
        </el-popover>
      </template>
    </div>
  </div>
  <Share v-model="shareVisible" :info="props.modelValue"/>
  <Report v-model="reportVisible" type="2" :reportId="props.modelValue.id"/>
  <Dialog
    v-model:visible="dialogVisible"
    :showFoot="false"
  >
    <p v-if="dialogContent.title" class="best-pick-title">
      <!-- {{ $t('closeThisThread') }} -->
      {{ dialogContent.title }}
    </p>
    <p v-if="dialogContent.content" class="delete-content">
      <!-- {{ $t('closeConfirm') }} -->
      {{ dialogContent.content }}
    </p>
    <div class="best-pick-btns">
      <el-button class="cancel" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
      <el-button class="save" @click="dialogContent.confirmFunction()">
        {{ dialogContent.confirmText }}
        <!-- {{ $t('closed') }} -->
      </el-button>
    </div>
  </Dialog>
  <AddLabel :threadInfo="modelValue" v-model="addLabelVisible"></AddLabel>
  <AddMedia v-model="addMediaVisible" :threadInfo="modelValue"></AddMedia>
  <!-- 选择理由弹窗 -->
  <Report v-model="reasonVisible" type="2" :reportId="props.modelValue.id" :reasonOnly="true" @afterSelect="afterSelectDel"/>
  <Dialog v-model:visible="moveVisible" :showFoot="false">
    <div class="move-title">
      <p>{{ $t('chooseACircle') }}</p>
      <svg-icon @click="moveVisible = false" class="icon-close" name="icon-close"></svg-icon>
    </div>
    <div class="editor">
      <div class="editor-selector">
        <el-dropdown 
          :teleported="false"
          trigger="click"
          popper-class="circle-select-wrap"
          :placeholder="$t('chooseCircle')"
          ref="selector"
          @visible-change="onVisible"
        > 
          <span v-if="state.circle.id" class="el-dropdown-text el-dropdown-selected">
            {{ state.circle.name }}
            <svg-icon name="icon-arrow-down" :class="state.spread ? 'spread' : ''"/>
          </span>
          <span v-else class="el-dropdown-text el-dropdown-placeholder">
            {{ $t('chooseCircle') }}
            <svg-icon name="icon-arrow-down" :class="state.spread ? 'spread' : ''"/>
          </span>
          <template #dropdown>
            <CircleGroup
              ref="circleGroupRef"
              v-model:selectedCircle="state.circle"
              v-model:selectedCircleTab="state.circleTab"
              :offsetTop="state.tabOffsetTop"
              :needRecommendCircle="false"
              @change="updateCircleData"
              :hasProfile="false"
            />
          </template>
        </el-dropdown>
        <p v-if="state.circleTab.id" class="circle-selected-tab" @click="openSelector">{{ state.circleTab.name }}</p>
      </div>
    </div>
    <div class="best-pick-btns">
      <el-button class="cancel" @click="moveVisible = false">{{ $t('cancel') }}</el-button>
      <el-button class="save" @click="onMove" :disabled="!state.circle.id">
        {{ $t('move') }}
      </el-button>
    </div>
  </Dialog>
  <!-- 编辑提示 -->
  <Dialog 
    v-model:visible="editOccupyVisible"
    :title="$t('postModule.notice')"
  >
    <p class="edit-lock">
      {{ $t('postModule.editOccupyMsg', {name:editOccupyUserName}) }}
    </p>
    <template #footer>
      <div class="edit-lock-footer">
        <el-button @click="editOccupyVisible = false" class="confirm">{{ $t('postModule.iUnderstand') }}</el-button>
      </div>
    </template>
  </Dialog>

  <!-- 合并帖子弹框 -->
  <Dialog :showFoot="false" v-model:visible="mergeThreadVisible" class="merge-dialog">
    <p class="best-pick-title"> {{ $t('mergeDialogTitle') }} </p>
    <p class="delete-content"> {{ $t('mergeDialogContent') }} </p>
    <el-input v-model="mergeLink" :placeholder="$t('mergeDialogPlaceholder')"></el-input>
    <div class="best-pick-btns">
      <el-button class="cancel" @click="canclMerge">{{ $t('cancel') }}</el-button>
      <el-button class="save" @click="toMergeThread">
        {{ $t('mergeDialogBtn') }}
      </el-button>
    </div>
  </Dialog>
</template>

<script setup>
import Share from '@/components/web/share'
import Report from '@/components/report'

import http from '@/service'
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user'
import { useSystemStore } from '@/stores/system'
import { $throttle } from '@/utils/lodashFuncs'



const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const systemStore = useSystemStore()
const { proxy } = getCurrentInstance()
const { isWeb } = storeToRefs(systemStore)
const { uid, getPermission } = storeToRefs(userStore)

const emit = defineEmits(['updateBestPick'])

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => {}
  }
})

// 操作选项
let actionList = ref([{
  iconName: 'unlike',
  value: 0
}, {
  iconName: 'msg',
  value: 1
}, {
  iconName: 'unmark',
  value: 2
}, {
  iconName: 'share',
  value: 3
}, {
  iconName: 'more',
  value: 4
}])


const actionBarRef = ref(null)
const selector = ref(null)
const popoverRef = ref(null)
const circleGroupRef = ref(null)
// 显示操作栏
const showAction = ref(false)
// 是否点赞
const praised = ref(false)
// 是否收藏
const collected = ref(false)
// 显示分享窗口
const shareVisible = ref(false)
// 举报窗口
const reportVisible = ref(false)
// 删除帖子选择理由弹窗
const reasonVisible = ref(false)
// 移动圈子弹窗
const moveVisible = ref(false)
// 操作弹窗是否显示
const dialogVisible = ref(false)
// 编辑有锁弹框
const editOccupyVisible = ref(false)
// 占用编辑帖子的用户名
const editOccupyUserName = ref('')
// 操作弹窗内容
const dialogContent = ref({})
// 添加标签
const addLabelVisible = ref(false)
// 添加媒体标签
const addMediaVisible = ref(false)
// 是否合并帖子
const mergeThreadVisible = ref(false)
const mergeLink = ref('')
// 是否精选状态
const bestPickStatus = ref(props.modelValue?.stamp*1)
// 添加精选
const onBestPick = async () => {
  const { code, msg, data } = await http[bestPickStatus.value ? 'highlightOff' :'highlightOn']({
    id: route.params.id,
  })
  if (code === 200 && data) {
    dialogVisible.value = false
    proxy.$toast({
      message: proxy.$t('succeed')
    })
    setTimeout(() => {
      bestPickStatus.value = !bestPickStatus.value
      moreOptions.value = bestPickStatus.value ? 'highlights' : 'unHighlights'
      emit('updateBestPick', bestPickStatus.value)
    }, 200)
  } else {
    proxy.$toast({
      message: msg
    })
  }
}

// 处理操作栏icon状态
watch(() => props.modelValue, (val) => {
  if (!val || !Object.keys(val).length) return
  praised.value = val.praised
  collected.value = val.collected
  actionList.value.find(i => i.iconName.includes('mark')).iconName = val.collected ? 'mark' : 'unmark'
  // 自己帖子不显示喜欢按钮
  if (uid.value === val.publishUserInfo.uid) {
    actionList.value = actionList.value.filter(i => !i.iconName.includes('like'))
  } else {
    actionList.value.find(i => i.iconName.includes('like')).iconName = val.praised ? 'like' : 'unlike'
  }
}, {
  immediate: true,
  deep: true
})

// 点赞
const onLike = $throttle(async (apiName) => {
  if (uid.value && uid.value === props.uid) return
  const currentApi = apiName === 'like' ? 'unlike' : 'like'
  const { code, msg, data } = await http[currentApi]({
    id: props.modelValue.id
  })
  if (code === 200) {
    let updateCount = props.modelValue.threadStat.praiseCount
    if (praised.value) {
      updateCount--
    } else {
      updateCount++
    }
    props.modelValue.threadStat.praiseCount = updateCount
    props.modelValue.praised = !praised.value
    actionList.value.find(i => i.iconName.includes('like')).iconName = props.modelValue.praised ? 'like' : 'unlike'
    proxy.$toast({
      message: `${proxy.$t(props.modelValue.praised ? 'like' : 'unlike')} ${proxy.$t('success')}`
    })
  }
}, 2000) 

// 收藏
const onMark = $throttle(async (apiName) => {
  const currentApi = apiName === 'mark' ? 'unmark' : 'mark'
  const { code, msg, data } = await http[currentApi]({
    id: props.modelValue.id
  })
  if (code === 200) {
    props.modelValue.collected = !collected.value
    
    actionList.value.find(i => i.iconName.includes('mark')).iconName = props.modelValue.collected ? 'mark' : 'unmark'
  }
}, 2000) 

// 分享
const onShare = () => {
  shareVisible.value = true
}

// 举报
const onReport = () => {
  if (!uid.value) {
    userStore.onLogin()
    return
  }
  reportVisible.value = true
}

// 编辑
const onEdit = async () => {
  // 权限列表
  const { threadEdit } = getPermission.value
  // 有编辑帖子特殊权限的用户，需要判断是否有其他人在编辑
  if (threadEdit) {
    const { code, msg, data } = await http.checkThreadEdit({
      tid: props.modelValue.id
    })
    if (code == 200 && !data.editStatus) {
      editOccupyUserName.value = data.occupyUserName
      editOccupyVisible.value = true
      return
    }
  }
  if (props.modelValue.status == 2) {
    proxy.$toast({
      message: proxy.$t('contentReview')
    })
    return
  }
  let type = 'article'
  switch (props.modelValue.type) {
    case 1:
      type = 'article'
      break
    case 2:
      type = 'moment'
      break
    case 4:
      type = 'poll'
      break
    default:
  }
  router.push({
    name: 'post',
    params: {
      type,
      id: props.modelValue.id
    }
  })
}


// 回到顶部icon显示处理
const watchScrollTop = (e) => {
  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollTop && !actionList.value.find(i => i.value === 5)) {
    actionList.value.push({
      iconName: 'top',
      value: 5
    })
  }
  if (!scrollTop && actionList.value.some(i => i.value === 5)) {
    actionList.value = actionList.value.filter(i => i.value !== 5)
  }
}

// icon触发
const onAction = ({ value, iconName }) => {
  switch (value) {
    case 0:
      onLike(iconName)
      break;
    case 1:
      sendGaData('comment_button_click', {
        "button_name": 'comment_button'
      })
      document.querySelector('.comment-menu').scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      })
      break;
    case 2:
      sendGaData(iconName === 'unmark' ? 'mark_thread' : 'unmark_thread', {
        "entry_position": route.name
      })
      onMark(iconName)
      break;
    case 3:
      let topic = ''
      if (props.modelValue && props.modelValue.topicInfo) {
        JSON.parse(props.modelValue.topicInfo).forEach((item, index) => {
          topic += item.name + (JSON.parse(props.modelValue?.topicInfo).length - 1  === index ? '' : ' + ')
        })
      }
      sendGaData('thread_share_entry', {
        "topic": topic,
        "author_id": props.modelValue?.publishUserInfo?.uid
      })
      onShare()
      break;
    case 4:
      break;
    default:
      document.documentElement.scrollTo({
        top: 0 ,
      })
  }
}

// 帖子操作选项
let options = ref([])
const moreOptions = computed({
  get: () => {
    // 帖子数据
    const threadInfo = props.modelValue
    // 是否归属圈子
    const hasCircle = threadInfo.circleBasicInfo && Object.keys(threadInfo.circleBasicInfo).length
    // 是否圈主
    const isCircleOwner = threadInfo.loginIdentityType > 0 && threadInfo.loginIdentityType <= 2
    // 是否作者
    const isAuthor = uid.value === threadInfo.publishUserInfo.uid
    // 权限列表
    const { threadMerge, threadStick, threadEdit, threadDelete, moveThread, hideThread, closeComment, label } = getPermission.value
    // buff为true 开启评论回复;buff为false 关闭评论回复
    const buff = threadInfo?.buff !== 1 && threadInfo?.buff !== 3
    
    options.value = [{
      name: 'edit', // 编辑
      show: isAuthor || threadEdit
    }, {
      name: 'report', // 举报
      show: uid.value !== threadInfo.publishUserInfo.uid
    }, {
      name: 'delete', // 删贴
      show: isAuthor || isCircleOwner || threadDelete,
      hasline: true
    },{
      name: threadInfo.stick ? 'cancelStick' : 'stick',  // 置顶
      show: (hasCircle && threadStick) || isCircleOwner,
    },  {
      name: bestPickStatus.value ? 'unHighlights' : 'highlights',
      show: label,
    },  {
      name: 'mergeBtn', // 合并帖子
      show: threadMerge && threadInfo.status == 1,
    }, {
      name: 'move', // 移动帖子
      show: moveThread,
    }, {
      name: threadInfo?.hide ? 'unExclude' : 'exclude',
      show: hideThread,
    }, {
      name: buff ? 'close' : 'unClose', // 关闭评论
      show: closeComment,
      // hasline: !((hasCircle && threadStick) || isCircleOwner)
    },{
      name: 'mediaLabel',
      show: label && (props.modelValue.attachments?.length || props.modelValue.ext?.length),
    }, {
      name: 'addLabel',
      show: label,
    }]
    return options.value.filter(i => i.show)
  },
  set: (type) => {
    if (type === 'stick') {
      options.value.find(i => i.name === type).name = 'cancelStick'
    }
    if (type === 'cancelStick') {
      options.value.find(i => i.name === type).name = 'stick'
    }
    if (type === 'highlights') {
      options.value.find(i => i.name === type).name = 'unHighlights'
    }
    if (type === 'unHighlights') {
      options.value.find(i => i.name === type).name = 'highlights'
    }
    if (type === 'unExclude') {
      options.value.find(i => i.name === type).name = 'exclude'
    }
    if (type === 'exclude') {
      options.value.find(i => i.name === type).name = 'unExclude'
    }
  }
})

const enterMoreActicon = () => {
  sendGaData('thread_more_action', {
    "button_name": 'Thread more actions',
  })
}

const onHandleThread = async ({ name }) => {
  const ga_name = {
    'stick': 'thread_pin_to_top',
    'cancelStick': 'thread_pin_to_top_cancel',
    'report': 'thread_report',
    'edit': 'thread_edit_entry',
    'delete': 'thread_delete'
  }
  if (ga_name[name]) {
    sendGaData(ga_name[name])
  }
  switch (name) {
    case 'stick':
    case 'cancelStick':
      onHandelStick(name)
      break
    case 'report':
      onReport()
      break
    case 'edit':
      await onEdit()
      break 
    case 'delete':
      deleteReason.value = ''
      if (uid.value === props.modelValue?.publishUserInfo.uid) {
        dialogContent.value = {
          title: proxy.$t('sureDelete'),
          content: '',
          confirmText: proxy.$t('delete'),
          confirmFunction: onDelteThread
        }
        dialogVisible.value = true
      } else {
        reasonVisible.value = true
      }
      break
    case 'close':
      dialogContent.value = {
        title: proxy.$t('closeThisThread'),
        content: proxy.$t('closeConfirm'),
        confirmText: proxy.$t('closed'),
        confirmFunction: onClose
      }
      dialogVisible.value = true
      break
    case 'unClose': 
      onClose('unClose')
      break
    case 'unExclude': 
      onExclude('unExclude')
      break
    case 'exclude': 
      dialogContent.value = {
        title: proxy.$t('excludeThisThread'),
        content: proxy.$t('excludeConfirm'),
        confirmText: proxy.$t('exclude'),
        confirmFunction: onExclude
      }
      dialogVisible.value = true
      break
    case 'addLabel':
      addLabelVisible.value = true
      break
    case 'mediaLabel':
      addMediaVisible.value = true
      break
    case 'highlights':
      dialogContent.value = {
        title: proxy.$t('markBestTitle'),
        content: proxy.$t('markBestContent'),
        confirmText: proxy.$t('markSave'),
        confirmFunction: onBestPick
      }
      dialogVisible.value = true
      break
    case 'unHighlights':
      dialogContent.value = {
        title: proxy.$t('markBestCancelTitle'),
        content: proxy.$t('markBestCancelContent'),
        confirmText: proxy.$t('markCancel'),
        confirmFunction: onBestPick
      }
      dialogVisible.value = true
      break
    case 'mergeBtn':
      mergeThreadVisible.value = true
      break
    case 'move':
      moveVisible.value = true
      state.circle = props.modelValue.circleBasicInfo ? {...props.modelValue.circleBasicInfo} : {id: 0, name: proxy.$t('myProfile')},
      state.circleTab = {...props.modelValue.circleBasicInfo?.circleTabInfo} || {},
      setTimeout(() => {
        selector.value.handleOpen()
      }, 200)
      break
    default:
  }
  popoverRef.value[0].hide()
}
// 帖子 置顶/取消置顶
const onHandelStick = async (type) => {
  const { code, data, msg } = await http[type]({
    circleId: props.modelValue.circleBasicInfo.id,
    tid: props.modelValue.id
  })
  if (code === 200 && data) {
    moreOptions.value = type
    proxy.$toast({
      message: `${proxy.$t(type)} ${proxy.$t('success')}`
    })
  } else {
    proxy.$toast({
      message: `${proxy.$t(type)} ${proxy.$t('fail')}`
    })
  }
}

// 关闭帖子
const onClose = async (type = 'close') => {
  const { code, msg, data } = await http[type === 'close' ? 'closeComment' : 'openComment']({
    id: route.params.id,
  })
  if (code === 200 && data) {
    dialogVisible.value = false
    moreOptions.value = type
    proxy.$toast({
      message: type === 'close' ? proxy.$t('threadClose')  : proxy.$t('unClosed')
    })
    setTimeout(() => {
      window.location.reload()
    }, 1000)
  } else {
    proxy.$toast({
      message: msg
    })
  }
}

// 隐藏帖子
const onExclude = async (type = 'exclude') => {
  const { code, msg, data } = await http[type === 'exclude' ? 'hideThread' : 'showThread']({
    id: route.params.id,
  })
  if (code === 200 && data) {
    dialogVisible.value = false
    moreOptions.value = type
    proxy.$toast({
      message: type === 'exclude' ? proxy.$t('excluded') : proxy.$t('unExcluded')
    })
  } else {
    proxy.$toast({
      message: msg
    })
  }
}

// 移动圈子
const state = reactive({
  circle: props.modelValue.circleBasicInfo ? {...props.modelValue.circleBasicInfo} : {id: 0, name: proxy.$t('myProfile')},
  circleTab: {...props.modelValue.circleBasicInfo?.circleTabInfo} || {},
  tabOffsetTop: '',
  spread: false
})

const updateCircleData = () => {
  nextTick(() => {
    selector.value.handleClose()
  })
}

const openSelector = () => {
  nextTick(() => {
    selector.value.handleOpen()
  })
}

const onVisible = (val) => {
  state.spread = val
}

const onMove = async () => {
  const { code, msg, data } = await http.moveThread({
    ids: [route.params.id],
    circleId: state.circle.id,
    circleTabId: state.circleTab?.id || null,
  })
  if (code === 200) {
    moveVisible.value = false
    proxy.$toast({
      message: proxy.$t('threadMoved')
    })
    setTimeout(() => {
      window.location.reload()
    }, 2000)
  } else {
    proxy.$toast({
      message: msg
    })
  }
}

const cancelDel = () => {
  sendGaData('thread_delete_popup', {
    "action": 'Cancel'
  })
}

const sendGaData = (name, data) => {
  let params = {
    "screen_name": route.name,
    "thread_category": props.modelValue.type,
    "thread_id": route.params.id,
    "circle_id": props.modelValue?.circleBasicInfo?.id,
    "circle_name": props.modelValue?.circleBasicInfo?.name,
  }
  proxy.$ga(name, {
    ...params,
    ...data
  })
}

function canclMerge(){
  mergeLink.value = ''
  mergeThreadVisible.value = false
}

// 合并帖子
async function toMergeThread(){
  if(!mergeLink.value){
    proxy.$toast({
      message: proxy.$t('pleaseEnter'),
    })
    return
  }

  // 先获取帖子状态，校验帖子是否能合并成功
  let res = await http.getThreadStatus({
    id: mergeLink.value.trim()
  })
  if (res.code == 200) {
    if(res.data !== 1){
      proxy.$toast({
        message: proxy.$t('mergeIdFail'),
      })
      return
    }
  }

  const { code, data, msg } = await http.mergeThread({
    tid: route.params.id,
    mergeToTid: mergeLink.value.trim()
  })
  if (code === 200) {
    proxy.$toast({
      message: proxy.$t('mergeSuccess'),
    })
    mergeThreadVisible.value = false
    window.location.reload()
  } else {
    proxy.$toast({
      message: proxy.$t('mergeFail'),
    })
  }
}

// 删除理由
const deleteReason = ref('')
// 删除帖子选择完理由
const afterSelectDel = (val) => {
  deleteReason.value = val.name
  onDelteThread()
  reasonVisible.value = false
  // 1312587251351289857
}

// 删除帖子
const onDelteThread = async () => {
  sendGaData('thread_delete_popup', {
    "action": 'Yes'
  })
  const { code, data, msg } = await http.deleteThread({
    id: props.modelValue.id,
    reason: deleteReason.value
  })
  if (code === 200 && data) {
    dialogVisible.value = false
    // 删除后返回上一页
    proxy.$toast({
      message: `${proxy.$t('delete')} ${proxy.$t('success')}`,
      onClose: () => {
        router.back()
      }
    })
  } else {
    proxy.$toast({
      message: `${proxy.$t('delete')} ${proxy.$t('fail')}`,
    })
  }
}

const resetActionBarPosition = () => {
  window.onresize = resetBar
  window.addEventListener('scroll', resetBar)
}

function resetBar (e) {
  if (!isWeb.value) return 
  const actionBarDom = document.querySelector('.action-bar')
  const left = document.querySelector('.thread-l').getBoundingClientRect().left + 47 + 792 - 31
  actionBarDom.style.left = `${left}px`
  actionBarDom.style.top = `30%`
}

function init () {
  resetActionBarPosition()
  // 获取操作栏上次定位
  let actionBarPosition = localStorage.getItem('actionBarPosition')
  actionBarPosition = JSON.parse(actionBarPosition)
  setTimeout(() => {
    const actionBarDom = document.querySelector('.action-bar')
    const left = document.querySelector('.thread-l').getBoundingClientRect().left + 47 + 792 - 31
    actionBarDom.style.left = `${left}px`
    actionBarDom.style.top = `30%`
    showAction.value = true
    window.onscroll = watchScrollTop
  }, 500)
}

onMounted(() => {
  init()
})

onActivated(() => {
  init()
})

onDeactivated(() => {
  // 移除事件
  window.onscroll = null
  window.onresize = null
  window.removeEventListener('scroll', resetBar)
})

onUnmounted(() => {
  // 移除事件
  window.onscroll = null
  window.onresize = null
  window.removeEventListener('scroll', resetBar)
})

</script>

<style lang="postcss" scoped>
.action-bar {
  position: fixed;
  width: fit-content;
  padding: 16px 6px;
  z-index: 1900;
  &-item {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border: 1px solid var(--line);
    border-radius: 100%;
    margin-bottom: 24px;
    cursor: pointer;
    background-color: #FFF;
    &:hover {
      background-color: #eeeeee;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .pop-trigger {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }
    .svg-icon {
      width: 24px;
      height: 24px;
      color: var(--text-primary);
    }
    .icon-like {
      color: #DF3D3D !important;
    }
  }
  &-more {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    justify-content: center;
    padding: 8px 0;
    overflow: hidden;
    dt {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      font-size: 14px;
      padding: 11px 24px;
      cursor: pointer;
      &:empty {
        display: none;
      }
    }
    dt:hover {
      background-color: var(--background-light);
    }
    .hasline {
      border-bottom: 1px solid #F0F0F0;
    }
  }
  
}
.delete-content {
  width: 385px;
  margin: 32px 32px 32px;
  font-size: 16px;
  display: grid;
  justify-items: center;
  word-break: break-word;
}
.best-pick-title {
  margin: 40px 64px 0 64px;
  text-align: center;
  font-size: 24px;
  font-family: 'orbit-M';
  color: var(--text-primary);
}
.best-pick-btns {
  text-align: center;
  margin: 32px 32px 40px;
  display: flex;
  .el-button {
    height: 52px;
    color: var(--text-primary-reverse);
    font-family: 'orbit-M';
    background: var(--theme);
    border-radius: var(--button-radius);
    margin-left: 12px;
    font-size: 16px;
    border: none;
    min-width: 186px;
    width: 100%;
  }
  .el-button.is-disabled {
    background: var(--theme-disabled);
  }
  .cancel {
    background: none;
    color: var(--text-primary);
    border: 1px solid var(--line);
    margin-left: 0px;
  }
}
.editor {
  width: 792px;
  margin: 0 auto;
  background-color: #FFF;
  height: 600px;
  .editor-selector {
    position: relative;
    width: calc(792px - 48px);
    padding: 24px 0;
    margin: 0 auto;
    box-shadow: 0 0.33px 0 0 var(--line) !important;
    .circle-selected-tab {
      font-size: 18px;
      margin-top: 8px;
      color: var(--text-secondary);
      line-height: 21px;
    }
  }
  :deep(.el-input) {
    --el-input-text-color: var(--text-primary);
    .el-input__sufix {
      .svg-icon {
        font-size: 24px;
      }
    }
  }
  .el-dropdown {
    --el-disabled-text-color: none;
    --el-font-size-base: 20px;
    --el-select-input-focus-border-color: none;
    --el-disabled-bg-color: transparent;
    width: 100%;
    :deep(.el-input__wrapper) {
      padding: 0;
      border-radius: 0;
      box-shadow: none;
      box-sizing: border-box;
    }
    .el-dropdown-text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .svg-icon {
        width: 18px;
        height: 18px;
        margin-left: 2px;
        transition: transform .3s;
        transform: rotate(0deg);
      }
      .spread {
        transition: transform .3s;
        transform: rotate(-180deg);
      }
    }
    .el-dropdown-selected {
      color: var(--text-primary);
    }
    .el-dropdown-placeholder {
      font-family: 'orbit-M';
      color: var(--text-hint);
    }
    :deep(.el-select-dropdown) {
      width: calc(792px - 48px);
      min-width: unset !important;
      .el-select-dropdown__item.is-disabled.selected,.el-select-dropdown__item.selected {
        color: var(--theme);
      }
      .el-select-dropdown__item:hover {
        background-color: transparent;
      }
      .el-select-dropdown__wrap {
        max-height: 459px;
      }
    }
    
    :deep(.el-scrollbar__bar) {
      z-index: 999;
    }
  }
  .el-select--disabled {
    :deep(.el-input__suffix) {
      display: none;
    }
  }
  
  .title {
    --el-input-border-radius: none;
    --el-font-size-base: 32px;
    margin-top: 1px;
    :deep(.el-input__wrapper) {
      .el-input__inner {
        --el-input-inner-height: 35px;
      }
      padding: 16px 24px;
      box-shadow: 0 0.33px 0 0 var(--line) !important;
    }
  }
  .poll-title {
    :deep(.el-input__wrapper) {
      box-shadow: none !important;
    }
  }
}
.move-title {
  width: 100%;
  text-align: center;
  margin: 40px 0 24px;
  color: #262626;
  font-size: 24px;
  font-family: 'orbit-M';
  .svg-icon {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 40px;
    right: 40px;
    color: var(--text-primary);
    z-index: 9999;
  }
}
:deep(.el-dialog) {
  background: #fff !important;
}
</style>

<style lang="postcss">
.el-popper {
  --el-popover-padding: 0;
  --el-popover-border-radius: 8px;
  .el-popper__arrow {
    display: none;
  }
}
.circle-select-wrap {
  --el-popover-border-radius: 0px 0px 12px 12px;
  width: 744px;
  .el-scrollbar__wrap {
    min-height: 300px;
    max-height: 500px;
  }
  .el-dropdown__list {
    padding-bottom: 0 !important;
  }
  .el-scrollbar__view {
    z-index: 90;
  }
  .el-input__wrapper {
    box-shadow: none;
  }
}

.edit-lock {
  box-sizing: border-box;
  width: 360px;
  margin: 0 40px;
  font-size: 18px;
  line-height: 120%;
  text-align: center;

  &-footer {
    margin: 32px 40px 40px;
    display:flex;
    
    button {
      width: 100%;
      height: 52px;
      font-size: 16px;
    }

    .confirm {
      background-color: var(--theme);
      color: #fff;
    }
  }
}

.merge-dialog{
  .el-input{
    width: calc(100% - 64px);
    margin: 0 32px;
    height: 52px;
    font-size: 16px;
    margin-top: -12px;
    .el-input__wrapper.is-focus{
      box-shadow: 0 0 0 1px #ccc inset;
    }
  }
}

</style>